import { render, staticRenderFns } from "./PanelProductLocation.vue?vue&type=template&id=9ec3c47c&scoped=true"
import script from "./PanelProductLocation.vue?vue&type=script&lang=js"
export * from "./PanelProductLocation.vue?vue&type=script&lang=js"
import style0 from "./PanelProductLocation.vue?vue&type=style&index=0&id=9ec3c47c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec3c47c",
  null
  
)

export default component.exports